export const SOLUTION_CATEGORIES = [
  {
    name: 'Home & Property Loan',
    slug: 'home-property-finance',
    items: [
      ['Home Loan', '/home-loan'],
      ['Home Loan Overdraft', '/home-loan-overdraft'],
      ['Loan Against Property', '/loan-against-property'],
      ['Loan Against Property Overdraft', '/loan-against-property-overdraft'],
      ['Commercial Property Purchase Loan', '/commercial-property-purchase'],
      ['Home Loans for NRI', '/home-loans-nri'],
      ['Loan Against Property for NRI', '/loan-against-property-nri'],
      ['Builder Finance', '/builder-finance'],
      ['Real Estate Funding', '/real-estate-funding']
    ]
  },
  {
    name: 'Business & Corporate Finance',
    slug: 'business-corporate-finance',
    items: [
      ['Business Loans', '/business-loans'],
      ['MSME Business Funding', '/msme-business-funding'],
      ['Working Capital Finance', '/working-capital-finance'],
      ['Unsecured Working Capital', '/unsecured-working-capital'],
      ['Term Loan', '/term-loan'],
      ['Debt Syndication', '/debt-syndication'],
      ['Project Finance', '/project-finance'],
      ['Infrastructure Funding', '/infrastructure-funding'],
      ['Solar Project Funding', '/solar-project-funding'],
      ['Funding for Schools', '/funding-for-schools'],
      ['Foreign Currency Funding', '/foreign-currency-funding']
    ]
  },
  {
    name: 'Trade & Supply Chain Finance',
    slug: 'trade-supply-chain-finance',
    items: [
      ['Trade Finance Solutions', '/trade-finance-solutions'],
      ['Supply Chain Finance', '/supply-chain-finance'],
      ['Vendor Financing', '/vendor-financing'],
      ['Bill Discounting', '/bill-discounting'],
      ['Factoring Finance', '/factoring-finance'],
      ['LC Discounting', '/lc-discounting'],
      ['Bank Guarantee', '/bank-guarantee']
    ]
  },
  {
    name: 'Structured Credit & Capital Markets',
    slug: 'structured-capital-markets',
    items: [
      ['Private Equity Funding', '/private-equity-funding'],
      ['Non-Convertible Debentures (NCD)', '/non-convertible-debentures'],
      ['Securitization', '/securitization'],
      ['Merger & Acquisition Advisory', '/merger-acquisition-advisory'],
      ['Debt Advisory', '/debt-advisory'],
      ['Capital Structuring', '/capital-structuring']
    ]
  },
  {
    name: 'Asset-Backed Lending',
    slug: 'asset-backed-lending',
    items: [
      ['Loan Against Shares', '/loan-against-shares'],
      ['Loan Against Mutual Funds', '/loan-against-mutual-funds'],
      ['Loan Against Fixed Deposits', '/loan-against-fixed-deposits'],
      ['Loan Against Gold & Silver', '/loan-against-gold-silver']
    ]
  },
  {
    name: 'Equipment & Machinery Finance',
    slug: 'equipment-machinery-finance',
    items: [
      ['Machinery Loan', '/machinery-loan'],
      ['Machinery Refinance', '/machinery-refinance'],
      ['Imported Machinery Finance', '/imported-machinery-finance'],
      ['Medical Equipment Finance', '/medical-equipment-finance'],
      ['Equipment Leasing', '/equipment-leasing']
    ]
  },
  {
    name: 'Professional & Education Finance',
    slug: 'professional-education-finance',
    items: [
      ['Doctors Loan', '/doctors-loan'],
      ['Chartered Accountant Loan', '/chartered-accountant-loan'],
      ['Company Secretary Loan', '/company-secretary-loan'],
      ['Architect Loan', '/architect-loan'],
      ['Lawyer Loan', '/lawyer-loan'],
      ['Education Loan', '/education-loan']
    ]
  },
  {
    name: 'Specialized Funding Solutions',
    slug: 'specialized-funding-solutions',
    items: [
      ['CGTMSE Loan', '/cgtmse-loan'],
      ['Project Report Funding', '/project-report-funding'],
      ['Personal Loan for Salaried', '/personal-loan-salaried']
    ]
  }
];

export const SECTOR_GROUPS = [
  {
    name: 'Manufacturing & Industrial',
    items: [
      ['Engineering', '/industries/engineering'],
      ['Auto Components', '/industries/auto-components'],
      ['Chemicals', '/industries/chemicals'],
      ['Metals', '/industries/metals'],
      ['Textiles', '/industries/textiles'],
      ['Packaging', '/industries/packaging'],
      ['Food Processing', '/industries/food-processing']
    ]
  },
  {
    name: 'Real Estate & Infrastructure',
    items: [
      ['Developers', '/industries/developers'],
      ['Contractors', '/industries/contractors'],
      ['EPC Companies', '/industries/epc-companies'],
      ['Infrastructure', '/industries/infrastructure'],
      ['Commercial Real Estate', '/industries/commercial-real-estate']
    ]
  },
  {
    name: 'Healthcare & Life Sciences',
    items: [
      ['Hospitals', '/industries/hospitals'],
      ['Doctors', '/industries/doctors'],
      ['Diagnostic Centres', '/industries/diagnostic-centres'],
      ['Pharmaceuticals', '/industries/pharmaceuticals'],
      ['Medical Equipment', '/industries/medical-equipment']
    ]
  },
  {
    name: 'Technology & Services',
    items: [
      ['IT Companies', '/industries/it-companies'],
      ['SaaS Businesses', '/industries/saas-businesses'],
      ['Consulting Firms', '/industries/consulting-firms'],
      ['Professional Services', '/industries/professional-services'],
      ['Media & Entertainment', '/industries/media-entertainment']
    ]
  },
  {
    name: 'Trade & Commerce',
    items: [
      ['Import & Export', '/industries/import-export'],
      ['Wholesale', '/industries/wholesale'],
      ['Retail', '/industries/retail'],
      ['E-commerce', '/industries/ecommerce'],
      ['Logistics', '/industries/logistics'],
      ['Supply Chain', '/industries/supply-chain']
    ]
  },
  {
    name: 'Education & Institutions',
    items: [
      ['Schools', '/industries/schools'],
      ['Colleges', '/industries/colleges'],
      ['Universities', '/industries/universities'],
      ['Educational Trusts', '/industries/educational-trusts']
    ]
  }
];
